<template>
  <Modal
    v-model="_value"
    width="400"
    title="修改密码"
    @on-visible-change="visibleChange"
    ok-text="修改密码"
    @on-ok="onOK"
    cancel-text="">
    <Form ref="loginForm">
      <FormItem prop="oldPassword">
        <label style="display: inline-block; width: 60px;">原密码</label>
        <Input type="password" style="display: inline-block; width: 250px;" v-model="oldPassword"
               placeholder="请输入原密码">
        </Input>
      </FormItem>
      <FormItem prop="newPassword">
        <label style="display: inline-block; width: 60px;">新密码</label>
        <Input type="password" style="display: inline-block; width: 250px;" v-model="newPassword"
               placeholder="请输入新密码">
        </Input>
      </FormItem>
      <FormItem prop="reNewPassword">
        <label style="display: inline-block; width: 60px;">重复新密码</label>
        <Input type="password" style="display: inline-block; width: 250px;" v-model="reNewPassword"
               placeholder="重复新密码">
        </Input>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>
  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'SelfInfoModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null
    },
    data() {
      return {
        oldPassword: null,
        newPassword: null,
        reNewPassword: null
      }
    },
    methods: {
      ...mapActions([
        'AccountServ_ModifyPassword'
      ]),
      onOK() {
        if(this.newPassword === null || this.reNewPassword === null || this.oldPassword === null){
          this.$Message.error('密码不能为空')
          return
        }
        if(this.newPassword !== this.reNewPassword){
          this.$Message.error('重复密码不一致')
          return
        }
        this.$Modal.confirm({
          title: '确认修改密码',
          content: '<p>确认修改密码</p>',
          onOk: () => {
            store.dispatch('AccountServ_ModifyPassword', {
              params: {newPassword:this.newPassword, oldPassword:this.oldPassword}
            }).then(() => {
              this.$Message.success('修改成功')
              this.$emit('on-success')
            }).catch(err => {
              this.$Message.error(err)
              this.$emit('on-fail')
            })
          },
          onCancel: () => {

          }
        })
      },
      visibleChange(val) {
        if (val) {
          this.oldPassword = null
          this.newPassword = null
          this.reNewPassword = null
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
